import { useEffect, useState } from "react";
import { ASSET_BROCHURE_URL, ASSET_VIGOR_URL, ASSET_FLYER_URL } from "@/lib/mailto";
import BrochureGateDialog from "@/components/BrochureGateDialog";

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = "ll_brochure_lead";

export const GATED_DOCS = {
  [ASSET_BROCHURE_URL]: { key: "brochure", title: "Brochure LevelLeven" },
  [ASSET_VIGOR_URL]: { key: "vigor", title: "LevelLeven × VIGOR" },
  [ASSET_FLYER_URL]: { key: "onepager", title: "One-pager LevelLeven" },
};

export const readLead = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
  } catch {
    return null;
  }
};

export const saveLead = (lead) => localStorage.setItem(STORAGE_KEY, JSON.stringify(lead));

export const postBrochureRequest = (body, opts = {}) =>
  fetch(`${API_BASE}/api/brochure/request`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...body, page: window.location.pathname }),
    ...opts,
  });

export function BrochureGateProvider({ children }) {
  const [active, setActive] = useState(null);

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest?.("a[href]");
      if (!a || a.hasAttribute("data-gate-skip")) return;
      const path = new URL(a.href, window.location.origin).pathname;
      const doc = GATED_DOCS[path];
      if (!doc) return;
      const lead = readLead();
      if (lead) {
        postBrochureRequest({ ...lead, doc: doc.key, herhaal: true }, { keepalive: true }).catch(() => {});
        return;
      }
      e.preventDefault();
      setActive({ ...doc, href: path });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return (
    <>
      {children}
      <BrochureGateDialog doc={active} onClose={() => setActive(null)} />
    </>
  );
}
